"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetLevelMode = void 0;
class BetLevelMode {
    get hasDifferingFeatureLevels() {
        return this._hasDifferingFeatureLevels;
    }
    get hasIndoMinBetLevels() {
        return this._hasIndoMinBetLevels;
    }
    get bet() {
        return this._bet;
    }
    get betLevels() {
        /*        const activeFeature = this._api.betFeatureController.getActiveBetFeature();
                if (activeFeature) {
                    return this.getFeatureBetLevels(activeFeature.name);
                }*/
        return this._allBetLevels;
    }
    get allBetLevels() {
        return this._allBetLevels;
    }
    constructor(modeName, data, api) {
        this._betLevels = [];
        this._allBetLevels = [];
        this._hasDifferingFeatureLevels = false;
        this._hasIndoMinBetLevels = false;
        this.modeName = modeName;
        this._bet = data.bet;
        this._api = api;
        this._featureBetLevels = {};
        this.updateAvailability(data);
    }
    addBuyTimesBetValue(data) {
        this._featureTimesBetValue = data;
    }
    addFeatureBetLevels(data) {
        for (let key in data) {
            this._featureBetLevels[key] = data[key];
        }
        this._hasDifferingFeatureLevels = this.checkForDifferingFeatureLevels(data);
        this.updateAllBetLevels();
    }
    updateAllBetLevels() {
        this._allBetLevels = this._betLevels.concat(); //All levels need to update together with betlevels!!!!!
        if (this._hasDifferingFeatureLevels) {
            for (let key in this._featureBetLevels) {
                this._allBetLevels = this._allBetLevels.concat(this._featureBetLevels[key]);
            }
        }
        //Remove duplicates
        this._allBetLevels = [...new Set(this._allBetLevels)];
        this._allBetLevels.sort((a, b) => {
            return parseFloat(a) - parseFloat(b);
        });
        //console.log("UPDATED _allBetLevels", this._allBetLevels);
    }
    checkForDifferingFeatureLevels(data) {
        this._differingFeatureBetLevels = {};
        this._indoMinBetLevels = {};
        const firstNormal = this._betLevels[0];
        for (let key in data) {
            this._differingFeatureBetLevels[key] = false;
            const firstFeature = data[key][0];
            if (parseFloat(firstFeature) < parseFloat(firstNormal)) {
                this._indoMinBetLevels[key] = true;
                this._hasIndoMinBetLevels = true;
            }
            for (let i = 0; i < this._betLevels.length; i++) {
                if (data[key][i] != this._betLevels[i]) {
                    this._differingFeatureBetLevels[key] = true;
                    break;
                }
            }
        }
        for (let key in this._differingFeatureBetLevels) {
            if (this._differingFeatureBetLevels[key]) {
                return true;
            }
        }
        return false;
    }
    doesFeatureHaveDifferingLevels(featureName) {
        return this._differingFeatureBetLevels[featureName];
    }
    doesFeatureHaveIndoMinBetLevels(featureName) {
        return this._indoMinBetLevels[featureName];
    }
    updateAvailability(data) {
        if (data.betLevels) {
            this._betLevels = data.betLevels;
        }
        else if (data.availableBetLevels && data.unavailableBetLevels) {
            this._betLevels = data.availableBetLevels.concat(data.unavailableBetLevels);
        }
        else {
            this._betLevels = [];
        }
        this._featureBetLevels["NORMAL"] = this._betLevels;
        this.updateAllBetLevels();
    }
    isFirst() {
        return this.betLevels.indexOf(this.bet) === 0 || this.betLevels.indexOf(this.bet) === -1;
    }
    isLast() {
        return this.betLevels.indexOf(this.bet) === this.betLevels.length - 1;
    }
    increase() {
        if (this.isLast()) {
            return false;
        }
        const index = this.betLevels.indexOf(this.bet) + 1;
        return this.setLevel(this.betLevels[index]);
    }
    decrease() {
        if (this.isFirst()) {
            return false;
        }
        const index = this.betLevels.indexOf(this.bet) - 1;
        return this.setLevel(this.betLevels[index]);
    }
    getLevel() {
        return this._bet;
    }
    get currentLevels() {
        const activeFeature = this._api.betFeatureController.getActiveBetFeature();
        const featureName = (activeFeature === null || activeFeature === void 0 ? void 0 : activeFeature.name) || "NORMAL";
        return this.getFeatureBetLevels(featureName);
    }
    setLevel(level) {
        if (this._bet != level) {
            this._bet = level;
            return true;
        }
        else {
            return false;
        }
    }
    searchForClosestValidLevel(level) {
        const levelNumber = parseFloat(level);
        if (levelNumber < parseFloat(this.currentLevels[0])) {
            level = this.currentLevels[0];
        }
        else {
            for (let i = this.currentLevels.length - 1; i >= 0; i--) {
                const validLevel = this.currentLevels[i];
                const validLevelNumber = parseFloat(validLevel);
                if (levelNumber >= validLevelNumber) {
                    level = validLevel;
                    break;
                }
            }
        }
        return level;
    }
    isValidBetForFeature(featureName) {
        var _a;
        if (((_a = this._featureBetLevels) === null || _a === void 0 ? void 0 : _a[featureName]) != undefined) {
            const index = this._featureBetLevels[featureName].indexOf(this._bet);
            return index > -1;
        }
        return false;
    }
    getValidLevels() {
        const activeFeature = this._api.betFeatureController.getActiveBetFeature();
        let levels = this._betLevels; //Normal mode levels.
        if (activeFeature) {
            levels = this.getFeatureBetLevels(activeFeature.name);
        }
        return levels;
    }
    getFeatureBetLevels(featureName) {
        var _a;
        if (((_a = this._featureBetLevels) === null || _a === void 0 ? void 0 : _a[featureName]) != undefined) {
            return this._featureBetLevels[featureName];
        }
        return [];
    }
    getMaxBetLevelForFeature(featureName) {
        var _a;
        if (((_a = this._featureBetLevels) === null || _a === void 0 ? void 0 : _a[featureName]) != undefined) {
            if (this._featureBetLevels[featureName].length > 0) {
                return this._featureBetLevels[featureName][this._featureBetLevels[featureName].length - 1];
            }
        }
        return "0";
    }
    getPriceForFeature(featureName) {
        for (let featureData of this._featureTimesBetValue) {
            if (featureData.name == featureName) {
                return featureData.price;
            }
        }
        throw new Error(`Could not find data for feature: ${featureName}`);
    }
    getTotalCostForBetLevel(level) {
        const activeFeature = this._api.betFeatureController.getActiveBetFeature();
        if (activeFeature) {
            return activeFeature.calculateCost(level);
        }
        return level;
    }
    addMetaData(metaData) {
        this.metaData = metaData;
    }
}
exports.BetLevelMode = BetLevelMode;
//# sourceMappingURL=BetLevelMode.js.map